<template lang="pug">
  div
    doc-markdown(source=`
    ## Input \`sw-input\`
    `)

    doc-preview(vue=`
    sw-input(
      v-model="input1"
      placeholder="This is an input field"
      custom-classes="max-w-md rounded border border-green-200 p-4 my-2 focus:border-blue-500 focus:outline-none"
      data-purpose-prop="example_button"
    )

    sw-input(
      v-model="input2"
      type="number"
      :min-value=10
      :max-value=10000
      placeholder="This is an input field of type number with slot"
      custom-classes="pl-10 max-w-md rounded border border-green-200 p-4 my-2 focus:border-blue-500 focus:outline-none"
    )
      .ml-4.w-4 €

    <script>
      ...
      data () {
        return {
          input1: null,
          input2: null,
        }
      }
    </script>
    `)
      sw-input(
        v-model="input1"
        placeholder="This is an input field"
        custom-classes="max-w-md rounded border border-green-200 p-4 my-2 focus:border-blue-500 focus:outline-none"
        data-purpose-prop="example_button"
      )

      sw-input(
        v-model="input2"
        type="number"
        placeholder="This is an input field of type number with slot"
        custom-classes="pl-10 max-w-md rounded border border-green-200 p-4 my-2 focus:border-blue-500 focus:outline-none"
      )
        .ml-4.w-4 €

    doc-markdown(source=`
    ### Slots
  | Slot name      | Description                                                             |
  |----------------|-------------------------------------------------------------------------|
  | *default*      | Optional slot to inject an HTML element in the input (such as a prefix).|
    `)

    doc-markdown(source=`
    ### Properties
  | Props                            | Description                            | Type           | Default |
  |----------------------------------|----------------------------------------|----------------|---------|
  | \`value\` (v-model)              | Value inputed.                         | String, Number | -       |
  | \`custom-classes\`               | Classes wrapping the whole component.  | String         | -       |
  | \`minValue\`                     | Minimum input using the input-arrows   | Number         | 0       |
  | \`minValue\`                     | Maximum input using the input-arrows   | Number         | 10000000|
  | \`type\`                         | Input type.                            | String         | 'string'|
  | \`placeholder\`                  | Placeholder text.                      | String         | -       |
  | \`data-purpose-prop\`            | Data purpose attribute.                | String         | -       |
    `)

    doc-markdown(id="events" source=`
    ### Events
  | Event name | Description                   | Parameters | Usage      |
  |------------|-------------------------------|:----------:|------------|
  | blur     | Triggered when input is blurred |    -       | \`@blur\`  |
  | focus   | Triggered when input is focused  |    -       | \`@focus\` |
  | input   | Triggered when value is inputed  |  value     | \`@input\` |
    `)
</template>

<script>
export default {
  data () {
    return {
      input1: null,
      input2: null,
    };
  },
};
</script>
